/* eslint-disable @typescript-eslint/no-unused-vars */
import { ScopelyIdentity } from "@scopely/web-sdk-scopely-account";
import { ApiResult } from "@scopely/web-sdk-scopely-account/dist/src/common/apiResult";
import { AudiencesAuthorizationResult } from "@scopely/web-sdk-scopely-account/dist/src/oauth2/model/AudiencesAuthorizationResult";
import { LogoutData } from "@scopely/web-sdk-scopely-account/dist/src/oauth2/model/logoutData";
import { LoginResult, LogoutResult } from "@scopely/web-sdk-scopelyid";
import { Dispatch, SetStateAction } from "react";
import { IDebugLogger } from "../../../utils/debugLogger";
//import { scopelyId } from "../config";
import {
	useHandleRedirect,
	useInitiateLogin,
	useStartLogin,
	useTryConcludeLogin
} from "./login";
import {
	getStartLogout,
	getTryConcludeLogout,
	useInitiateLogout,
	useLogoutRedirect
} from "./logout";

export interface IScopelyIdentityApi {
	initiateLogin: (origPath: string) => Promise<void>;
	/* loginRedirect: (
		onSuccess?: () => void
	) => Promise<ApiResult<AudiencesAuthorizationResult>>; */
	/* loginRedirect:
		| ((
				onSuccess?: () => void
		  ) => Promise<ApiResult<AudiencesAuthorizationResult>>)
		| undefined; */
	loginRedirect: (onSuccess?: () => void) => Promise<LoginResult | null>;
	initiateLogout: (logoutActionType: string, origPath: string) => Promise<void>;
	logoutRedirect: (onSuccess?: () => void) => Promise<LogoutResult | null>;
	//logoutRedirect: (onSuccess?: () => void) => Promise<ApiResult<LogoutData>>;
	/** @deprecated */
	startLogin: (origPath: string) => Promise<void>;
	/** @deprecated */
	startLogout: (logoutActionType: string, origPath: string) => Promise<void>;
	/** @deprecated */
	tryConcludeLogin: (onSuccess?: () => void) => Promise<LoginResult | null>;
	/** @deprecated */
	tryConcludeLogout: (onSuccess?: () => void) => Promise<LogoutResult | null>;
}
/* eslint-enable */

export const useInitAPI = ({
	scopelyIdentity,
	setSIDAccessToken,
	setSIDIdentityToken,
	setScopelyIdentityToken
}: //debug
{
	scopelyIdentity: ScopelyIdentity | null;
	setSIDAccessToken: Dispatch<SetStateAction<string | null>>;
	setSIDIdentityToken: Dispatch<SetStateAction<string | null>>;
	setScopelyIdentityToken: Dispatch<SetStateAction<string | null>>;
	//debug: IDebugLogger;
}): IScopelyIdentityApi => {
	return {
		initiateLogin: useInitiateLogin(scopelyIdentity),
		loginRedirect: useHandleRedirect({
			scopelyIdentity,
			setSIDAccessToken,
			setSIDIdentityToken,
			setScopelyIdentityToken
		}),
		initiateLogout: useInitiateLogout(scopelyIdentity),
		logoutRedirect: useLogoutRedirect({
			scopelyIdentity,
			setSIDAccessToken,
			setSIDIdentityToken,
			setScopelyIdentityToken
		}),
		startLogin: async () => undefined,
		tryConcludeLogin: async () => null,
		startLogout: async () => undefined,
		tryConcludeLogout: async () => null
	};
};
